import { map, set, size } from 'lodash';

import {
  ConditionInclusion,
} from 'client/Security/data/Condition';

import {
  ConditionTypeSerializer,
} from 'client/Security/data/ConditionItems';

/** @Module AuthNPolicyConditionsType */

/**
 * @typedef ConditionExpression
 * @property {string} type
 * @property {string} status
 * @property {string[]} ips Only used for IpList expressions
 */

/**
* @typedef AuthNPolicyConditions
* @property {string} inclusion
* @property {ConditionExpression[]} expressions
*/

/**
 * @param {object} expressions from API
 * @returns {ConditionExpression}
 */
function AuthNPolicyConditionsExpressionType(expression) {
  const firstKey = Object.keys(expression)[0];

  const isExclusion = firstKey === 'not';

  const expressionContent = isExclusion
    ? expression.not
    : expression;

  return ConditionTypeSerializer[Object.keys(expressionContent)[0]](
    expressionContent,
    isExclusion,
  );
}

/**
 * @param {*} args
 * @param {*} defaultPolicy
 */
export default function AuthNPolicyConditionsType(args = {}, defaultConditions = {}) {
  const conditions = {
    ...defaultConditions,
    ...args,
  };

  function formatExpressions(expressions) {
    return expressions
      .filter(expression => expression != null && Object.keys(expression).length > 0)
      .reduce((expressionsObject, expression) => {
        const formattedExpression = AuthNPolicyConditionsExpressionType(expression);

        return set(expressionsObject, formattedExpression.type, formattedExpression);
      }, {});
  }

  // Determine type of root node
  switch (Object.keys(conditions)[0]) {
    case 'any':
      this.inclusion = ConditionInclusion.any;
      this.expressions = formatExpressions(conditions.any);
      break;
    case 'all':
      this.inclusion = ConditionInclusion.all;
      this.expressions = formatExpressions(conditions.all);
      break;
    case 'not':
      this.inclusion = ConditionInclusion.all;
      this.expressions = formatExpressions([conditions]);
      break;
    default:
      this.inclusion = ConditionInclusion.all;
      this.expressions = formatExpressions([conditions]);
      break;
  }

  return this;
}

/**
 * @param {AuthNPolicyConditions} conditions
 * @returns Conditions formatted for the API
 */
export function formatAuthNPolicyConditionsForApi(conditions) {
  if (size(conditions.expressions) === 0) {
    return null;
  }

  const expressions = map(conditions.expressions, expression => expression.toApi())
    .filter(expression => expression != null);

  return (expressions.length === 1)
    ? expressions[0] // Don't return wrapped in an inclusion if we only have one expression
    : { [conditions.inclusion]: expressions }; // Return expressions wrapped in the inclusion value
}
